export default __webpack_public_path__ + "static/market-index-treemap-7f9089f1bdb5a128f9cb109ca7b6407e.png";